var UiLoadingBull = {
  name: 'UiLoadingBull',
  props: {
    value: {
      type: Boolean,
      default: true
    },
    size: {
      type: Number,
      default: 32
    },
    imageInfo: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      backgroundPosition: '0 0',
      clearIntervalIndex: null,
      xIndex: 0,
      yIndex: 0
    };
  },
  model: {
    prop: 'value'
  },
  mounted: function mounted() {
    this.init();
  },
  watch: {
    value: function value(_value) {
      if (_value) {
        this.run();
      } else {
        this.stop();
      }
    }
  },
  methods: {
    run: function run() {
      var _this = this;

      if (!this.value) return;
      this.clearIntervalIndex = setInterval(function () {
        _this.backgroundPosition = _this.getPosition();
      }, this.imageInfo.speed);
    },
    stop: function stop() {
      clearInterval(this.clearIntervalIndex);
    },
    getPosition: function getPosition() {
      var _this2 = this;

      var getIndex = function getIndex() {
        _this2.xIndex++;

        if (_this2.xIndex > _this2.imageInfo.XSLIDE - 1) {
          _this2.xIndex = 0;
          _this2.yIndex++;

          if (_this2.yIndex > _this2.imageInfo.YSLIDE - 1) {
            _this2.yIndex = 0;
            return [_this2.xIndex, _this2.yIndex];
          } else {
            return [_this2.xIndex, _this2.yIndex];
          }
        } else {
          return [_this2.xIndex, _this2.yIndex];
        }
      };

      var indexList = getIndex();
      var rate = (this.size / this.imageInfo.SIZE).toFixed(8);
      var xPosition = -this.imageInfo.WIDTH * rate / this.imageInfo.XSLIDE * indexList[0] + "px";
      var yPosition = -this.imageInfo.HEIGHT * rate / this.imageInfo.YSLIDE * indexList[1] + "px";
      return xPosition + " " + yPosition;
    },
    init: function init() {
      this.run();
    }
  },
  computed: {
    backgroundSize: function backgroundSize() {
      var rate = (this.size / this.imageInfo.SIZE).toFixed(8);
      return rate * this.imageInfo.WIDTH + "px " + rate * this.imageInfo.HEIGHT + "px";
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "style": {
        width: this.size + "px",
        height: this.size + "px",
        display: "inline-block",
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(" + this.imageInfo.IMAGE + ")",
        backgroundSize: "" + this.backgroundSize,
        backgroundPosition: this.backgroundPosition
      }
    });
  }
};

UiLoadingBull.install = function (Vue) {
  Vue.component(UiLoadingBull.name, UiLoadingBull);
};

export default UiLoadingBull;